import {
    // FETCH_USER_DETAILS,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILED,

    UPDATE_USER_DETAILS,
    UPDATE_USER_DETAILS_SUCCESS,
    UPDATE_USER_DETAILS_FAILED,

    // FETCH_USER_COUNTRIES,
    FETCH_USER_COUNTRIES_SUCCESS,
    FETCH_USER_COUNTRIES_FAILED,

    // GET_LIST_OF_SPECIALISATION,
    GET_LIST_OF_SPECIALISATION_SUCCESS,
    GET_LIST_OF_SPECIALISATION_FAILED,

    FETCH_DEVICES_LIST,
    FETCH_DEVICES_LIST_SUCCESS,
    FETCH_DEVICES_LIST_FAILED,

    FETCH_AVAILABLE_DEVICES,
    FETCH_AVAILABLE_DEVICES_SUCCESS,
    FETCH_AVAILABLE_DEVICES_FAILED,

    DEVICE_OPERATION,
    DEVICE_OPERATION_SUCCESS,
    DEVICE_OPERATION_FAILED,
    RESET_DEVICE_OPERATION_RESPONSE,

    DEPLOY_DEVICE_IN_PAST_DATE,
    DEPLOY_DEVICE_IN_PAST_DATE_SUCCESS,
    DEPLOY_DEVICE_IN_PAST_DATE_FAILED,

    FETCH_DEVICE_HISTORY,
    FETCH_DEVICE_HISTORY_SUCCESS,
    FETCH_DEVICE_HISTORY_FAILED,

    FETCH_AVAILABLE_DEVICES_DATES,
    FETCH_AVAILABLE_DEVICES_DATES_SUCCESS,
    FETCH_AVAILABLE_DEVICES_DATES_FAILED,

    FETCH_FUTURE_ALLOCATIONS,
    FETCH_FUTURE_ALLOCATIONS_SUCCESS,
    FETCH_FUTURE_ALLOCATIONS_FAILED,

    CANCEL_FUTURE_ALLOCATIONS,
    CANCEL_FUTURE_ALLOCATIONS_SUCCESS,
    CANCEL_FUTURE_ALLOCATIONS_FAILED,

    FETCH_LIVE_DEVICES,
    FETCH_LIVE_DEVICES_SUCCESS,
    FETCH_LIVE_DEVICES_FAILED,

    RESET_PATIENT_PASSWORD,
    RESET_PATIENT_PASSWORD_SUCCESS,
    RESET_PATIENT_PASSWORD_FAILED,
    RESET_PATIENT_PASSWORD_STATE,
    RESET_UPDATE_USER_DETAILS,
    RESET_DEPLOY_DEVICE_IN_PAST_DATE
} from "constants/ActionTypes";

const INIT_STATE = {
    loading: false,
    alertMessage: "",
    showMessage: false,
    initURL: "",
    authUser: localStorage.getItem("user_id"),
    is_authenticated: false,
    is_authorized: false,
    is_annotator: false,
    devices_list: [
        {
            device_id: "123",
            device_master_id: "Sleepiz_123",
            device_allocation_date: "August 30th 04:03 pm "
        },
        {
            device_id: "124",
            device_master_id: "Sleepiz_124",
            device_allocation_date: "1567160280000"
        }
    ],
    fetching_devices_list: false,
    update_user_details: false,
    fetching_available_devices: false,
    fetching_available_devices_failed: false,
    fetch_user_countries: false,
    get_list_of_specialisation: false,
    view_profile: true,
    device_operation_success_response: "",
    available_devices_dates: [],
    fetching_future_allocations: false,
    future_allocations_data: null,
    canceling_future_allocations: false,
    cancel_future_allocations_data: null,

    fetching_live_devices: false,
    live_devices_data: [],
    live_device_list: [],


    deploying_device_in_past_date: false,
    deployed_device_in_past_date: {}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_USER_DETAILS_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetching_user_details: false,
                is_authenticated: true,
                is_annotator: action.payload.user_details.is_annotator,
                is_authorized: true
            };
        }
        case FETCH_USER_DETAILS_FAILED: {
            return {
                ...state,
                fetching_user_details: false,
                is_authenticated: true,
                is_authorized: false
            };
        }
        case FETCH_DEVICES_LIST: {
            return {
                ...state,
                fetching_devices_list: true
            };
        }
        case FETCH_DEVICES_LIST_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetching_devices_list: false,
                device_operation_success_response: ""
            };
        }
        case RESET_DEVICE_OPERATION_RESPONSE: {
            return {
                ...state,
                device_operation_success_response: '',
                device_operation_error_response: ''

            }
        }
        case FETCH_DEVICES_LIST_FAILED: {
            return {
                ...state,
                fetching_devices_list: false
            };
        }
        case UPDATE_USER_DETAILS: {
            return {
                ...state,
                updating_user_details: true,
                update_user_details: true,

            };
        }
        case UPDATE_USER_DETAILS_SUCCESS: {
            return {
                ...state,
                update_user_details: true,
                updating_user_details: false,
                update_profile_error: false
            };
        }
        case UPDATE_USER_DETAILS_FAILED: {
            return {
                ...state,
                update_user_details: false,
                updating_user_details: false,
                update_profile_error: true,
                password_mismatch: action.payload || action.error
            };
        }
        case RESET_UPDATE_USER_DETAILS: {
            return {
                ...state,
                update_user_details: false,
            }
        }
        case FETCH_AVAILABLE_DEVICES: {
            return {
                ...state,
                deployed_device_in_past_date: {},
                fetching_available_devices: true,
                fetching_available_devices_failed: false
            };
        }
        case FETCH_AVAILABLE_DEVICES_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetching_available_devices: false,
                fetching_available_devices_failed: false,
                device_operation_success_response: ""
            };
        }
        case RESET_PATIENT_PASSWORD_STATE: {
            return {
                ...state,
                reset_patient_password_success: false,
                reset_patient_password_failed: false
            }
        }
        case RESET_PATIENT_PASSWORD_SUCCESS: {
            return {
                ...state,
                reset_patient_password_success: true
            }
        }
        case RESET_PATIENT_PASSWORD_FAILED: {
            return {
                ...state,
                reset_patient_password_failed: true
            }
        }
        case RESET_PATIENT_PASSWORD: {
            return {
                ...state,
                reset_patient_password_failed: false,
                reset_patient_password_success: false
            }
        }
        case FETCH_AVAILABLE_DEVICES_FAILED: {
            return {
                ...state,
                fetching_available_devices: false,
                fetching_available_devices_failed: true
            };
        }
        case FETCH_USER_COUNTRIES_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetch_user_countries: false,
                device_operation_success_response: "",
            };
        }
        case FETCH_USER_COUNTRIES_FAILED: {
            return {
                ...state,
                fetch_user_countries_failed: true
            };
        }
        case GET_LIST_OF_SPECIALISATION_SUCCESS: {
            return {
                ...state,
                specialisation: action.payload,
                get_list_of_specialisation: false,
                get_list_of_specialisation_failed: false
            };
        }
        case GET_LIST_OF_SPECIALISATION_FAILED: {
            return {
                ...state,
                get_list_of_specialisation: false,
                get_list_of_specialisation_failed: true
            };
        }
        case DEVICE_OPERATION: {
            return {
                ...state,
                device_operation_success_response: ""
            }
        }
        case DEVICE_OPERATION_SUCCESS: {
            return {
                ...state,
                device_operation_success_response: action.data
            }
        }
        case DEVICE_OPERATION_FAILED: {
            return {
                ...state,
                device_operation_error_response: action.error || 'Device Deployment failed for unknown reasons!',
                error: action.error
            }
        }
        case DEPLOY_DEVICE_IN_PAST_DATE: {
            return {
                ...state,
                deploying_device_in_past_date: true,
                deployed_device_in_past_date: {},
            }
        }
        case DEPLOY_DEVICE_IN_PAST_DATE_SUCCESS: {
            return {
                ...state,
                deploying_device_in_past_date: false,
                deployed_device_in_past_date: action.data
            }
        }
        case DEPLOY_DEVICE_IN_PAST_DATE_FAILED: {
            return {
                ...state,
                deploying_device_in_past_date: false,
                deployed_device_in_past_date: action.data
            }
        }
        case RESET_DEPLOY_DEVICE_IN_PAST_DATE: {
            return {
                ...state,
                deployed_device_in_past_date: {}
            }
        }
        case FETCH_DEVICE_HISTORY: {
            return {
                ...state
            }
        }
        case FETCH_DEVICE_HISTORY_SUCCESS: {
            return {
                ...state,
                device_history_response: action.data
            }
        }
        case FETCH_DEVICE_HISTORY_FAILED: {
            return {
                ...state,
                error: action.error
            }
        }
        case FETCH_AVAILABLE_DEVICES_DATES: {
            return {
                ...state
            }
        }
        case FETCH_AVAILABLE_DEVICES_DATES_SUCCESS: {
            return {
                ...state,
                available_devices_dates: action.data.data.calendar_available_dates
            }
        }
        case FETCH_AVAILABLE_DEVICES_DATES_FAILED: {
            return {
                ...state,
                error: action.error
            }
        }

        case FETCH_FUTURE_ALLOCATIONS: {
            return {
                ...state,
                ...action.payload,
                fetching_future_allocations: true,
            }
        }
        case FETCH_FUTURE_ALLOCATIONS_SUCCESS: {
            return {
                ...state,
                future_allocations_data: { ...action.data },
                fetching_future_allocations: false,
            }
        }
        case FETCH_FUTURE_ALLOCATIONS_FAILED: {
            return {
                ...state,
                error: action.error,
                fetching_future_allocations: false,
            }
        }

        case CANCEL_FUTURE_ALLOCATIONS: {
            return {
                ...state,
                ...action.payload,
                canceling_future_allocations: true,
            }
        }
        case CANCEL_FUTURE_ALLOCATIONS_SUCCESS: {
            return {
                ...state,
                cancel_future_allocations_data: { ...action.data },
                canceling_future_allocations: false,
            }
        }
        case CANCEL_FUTURE_ALLOCATIONS_FAILED: {
            return {
                ...state,
                error: action.error,
                canceling_future_allocations: false,
            }
        }

        case FETCH_LIVE_DEVICES: {
            return {
                ...state,
                fetching_live_devices: true,
            }
        }
        case FETCH_LIVE_DEVICES_SUCCESS: {
            let device_id = []
            action.data.live_devices.forEach(r => {
                if (r !== null)
                    device_id.push(r.device_id)
            })
            return {
                ...state,
                live_device_list: action.data.live_devices,
                live_devices_data: device_id,
                fetching_live_devices: false,
            }
        }
        case FETCH_LIVE_DEVICES_FAILED: {
            return {
                ...state,
                error: action.error,
                fetching_live_devices: false,
            }
        }

        default:
            return state;
    }
};
